import Policy from "component/Common/PolicyComponent";
import { formatPrice } from "helpers/common";
import { useHotelContext } from "hooks/hotel/useHotelContext";
import { Card, CardBody, CardTitle } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsPatchCheckFill } from "react-icons/bs";
import { FaBed, FaChild, FaPerson } from "react-icons/fa6";

const SideBar = () => {
    const { hotelSelection } = useHotelContext();
    const { t } = useTranslation();
    return (
        <>
            <div className="px-2 md:px-0">
                <Card as={CardBody} className="border mb-3 rounded-md">
                    <div className="d-sm-flex justify-content-sm-between align-items-center mb-3">
                        <div>
                            <span>{t("total")}</span>
                            <div className="text-default fw-bold fs-4 mb-0">
                                {formatPrice(
                                    hotelSelection?.totalPrice
                                ).replace("DA", t("DA"))}
                            </div>
                        </div>
                    </div>
                    {hotelSelection?.seletedRates?.map((rate, idx) => {
                        return (
                            <div className="bg-hover-color p-1 px-2 text-[13px] mb-2 rounded-md">
                                <div
                                    key={idx}
                                    className="d-flex align-items-center gap-2 mb-1"
                                >
                                    <span className="fw-bold d-flex gap-2">
                                        <FaBed className="" />
                                    </span>
                                    <span className="d-flex align-items-center  d-flex gap-2">
                                        <FaPerson className="" />{" "}
                                        {rate.persons?.adults}{" "}
                                        {rate.persons.adults === 1
                                            ? t("adult")
                                            : t("adults")}
                                    </span>
                                    {rate.persons.children > 0 && (
                                        <span className="d-flex align-items-center d-flex gap-2">
                                            <FaChild className="" />{" "}
                                            {rate.persons.children}{" "}
                                            {rate.persons.children === 1
                                                ? t("child")
                                                : t("children")}
                                        </span>
                                    )}
                                </div>
                                <div className="align-items-center d-flex gap-2">
                                    <div className="flex justify-center">
                                        <BsPatchCheckFill size={12} />
                                    </div>
                                    <div className="truncate">{rate.name}</div>
                                </div>
                                <div className="align-items-center d-flex gap-2">
                                    <div className="flex justify-center">
                                        <BsPatchCheckFill size={12} />
                                    </div>
                                    <div className="truncate">
                                        {rate.pension}
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    {formatPrice(rate.price).replace(
                                        "DA",
                                        t("DA")
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </Card>
                <Card as={CardBody} className="border mb-3 rounded-md">
                    <div className="text-default fw-bold fs-5 mb-3">
                        {t("cancellationPolicy")}
                    </div>
                    {hotelSelection?.seletedRates[0].cancellationPolicies &&
                        hotelSelection?.seletedRates.map((rate, idx) => {
                            return (
                                <div key={idx} className="text-[14px]">
                                    <div className="flex gap-2 items-center">
                                        <div className="">
                                            <FaBed size={12} />
                                        </div>
                                        <div className="truncate">
                                            {rate?.name}
                                        </div>
                                    </div>
                                    {rate?.cancellationPolicies?.map(
                                        (policy, idx) => {
                                            return (
                                                <Policy
                                                    key={idx}
                                                    policy={policy}
                                                />
                                            );
                                        }
                                    )}
                                </div>
                            );
                        })}
                    {!hotelSelection?.seletedRates[0].cancellationPolicies &&
                        hotelSelection?.cancellationPolicies?.map(
                            (policy, idx) => {
                                return <Policy key={idx} policy={policy} />;
                            }
                        )}
                    <div className="flex rounded-md bg-red-100 border text-red-700 border-red-700 p-2 w-full items-center">
                        <div className="d-flex gap-2 fw-light small mb-0">
                            <span className="badge bg-danger items-center ">
                                {t("important")}
                            </span>
                            <span
                                className="text-default"
                                style={{ fontSize: "13px" }}
                            >
                                {t("importantNote")}
                            </span>
                        </div>
                    </div>
                </Card>
                <Card className="border p-4">
                    <CardTitle as="div" className="mb-3">
                        <div className="mb-0 text-default fs-5 fw-bold ">
                            {t("needHelp")}
                        </div>
                    </CardTitle>
                    <p className="mb-2">{t("needHelpDescription")}</p>
                    <div className="text-default fs-4 fw-bold ">
                        +213 770268725
                    </div>
                </Card>
            </div>
        </>
    );
};

export default SideBar;
